interface LanguageSuggestion {
  id: string;
  name: string;
}

interface LanguageConfig {
  data: {
    languages: {
      en: string;
      no: string;
      es: string;
    };
    domainSuggestions: string[];
    languagesSuggestions: LanguageSuggestion[];
    currencySuggestions: string[];
  };
}

const config: LanguageConfig = {
  data: {
    languages: {
      en: 'en',
      no: 'no',
      es: 'es',
    },
    domainSuggestions: ['no', 'es'],
    languagesSuggestions: [
      { id: 'en', name: 'English' },
      { id: 'no', name: 'Norsk' },
      { id: 'es', name: 'Español' },
    ],
    currencySuggestions: ['NOK', 'EUR'],
  },
};

export default config;
export type { LanguageSuggestion, LanguageConfig };
